namespace TabAurous.Retail {
}
